import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useActorUser } from "@-/dev.improve.haniverse.lib.user";
import { NavContext } from "@-/dev.improve.haniverse.routes.nav._context";

export function useEffectiveIsToneColorsEnabled() {
  const { isToneColorsEnabled } = useActorUser();
  const [isToneColorsEnabledOverride] = useContextSelectors(
    NavContext,
    (c) => c.isToneColorsEnabledOverride,
  );
  return isToneColorsEnabledOverride ?? isToneColorsEnabled;
}
